import React from 'react';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Arrow from '../Assests/Group 2 (2).png';
import CardGrid from '../Components/CardGrid';
import arr from '../Assests/Group 2.png';
import Aos from 'aos';
import 'aos/dist/aos.css';
import Testimonials from './Testimonials';
const Work = () => {

  useEffect(() => {
    Aos.init({ duration: 1000 });
  }, []);

  const services = [
    {
      number: '01',
      title: 'Front-End',
      description: 'Crafting responsive, visually appealing user interfaces to deliver seamless user experiences across devices.',
    },
    {
      number: '02',
      title: 'Back-End',
      description: 'Building robust server-side systems and APIs to power dynamic and scalable applications.',
    },
    {
      number: '03',
      title: 'Integration',
      description: 'Seamlessly connecting systems and tools for cohesive workflows and enhanced functionality.',
    },
    {
      number: '04',
      title: 'Database Management',
      description: 'Designing and optimizing databases to ensure secure, efficient, and reliable data handling.',
    },
  ];
  

  return (
    <div className="text-white font-inria mt-10 md:mt-20 mx-10 lg:mx-20 ">
      <div className="flex flex-col lg:flex-row">
        <div className="mt-20 ml-10 lg:mt-28 lg:ml-20 flex-shrink-0 lg:w-1/3" data-aos='fade-right'>
          <div className="w-full lg:w-96">
            <h1 className="text-4xl lg:text-6xl">My Work</h1>
          </div>
          <div className="mt-10">
            <Link to='/work' className="flex gap-4 lg:gap-10 cursor-pointer" id='blink'>
              <h1 className="text-2xl lg:text-4xl">View More</h1>
              <img src={Arrow} alt="Arrow" className='mt-1' />
            </Link>
          </div>
        </div>
        <div className="mt-10 lg:mt-0 lg:ml-10 w-full lg:w-2/3" >
          <CardGrid displayCount={2} gridTemplate="grid-cols-1 md:grid-cols-2"/>
        </div>
      </div>
      <div className="text-white mt-10 md:mt-20">
        <div className="flex flex-col lg:flex-row">
          <div className="mb-10 ml-16 lg:mb-0 lg:ml-32 mt-10 lg:mt-48 flex-shrink-0 lg:w-1/4" data-aos='fade-right'>
            <h2 className="text-5xl lg:text-7xl font-semibold">Services</h2>
            <div className="mt-4 lg:ml-10">
              <img src={arr} alt="Arrow" />
            </div>
          </div>
          <div className="ml-0 lg:ml-32 lg:mr-20 w-full lg:w-3/4" data-aos='fade-left'>
            {services.map((service, index) => (
              <div key={index} className="flex mb-8 flex-col md:flex-row">
                <div className="flex-shrink-0 mt-4 lg:mt-6">
                  <h3 className="text-3xl lg:text-5xl font-bold mr-4"  data-aos="zoom-in">{service.number}</h3>
                </div>
                <div>
                  <h4 className="text-2xl text-left font-semibold lg:text-4xl  md:text-center " data-aos="flip-down">{service.title}</h4>
                  <hr className="mt-2 border-gray-700" />
                  <p className="mt-2 text-gray-400 text-lg lg:text-xl text-center lg:text-left" data-aos="flip-down">{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* <div>
        <Test/>
      </div> */}
      <div>
        <Testimonials/>
      </div>
    </div>
  );
};

export default Work;
